$(document).on("click", "#dashboard-machine-set-maintenance", function(){
  const record_id = $("#mid").attr("mid")

  $.ajax({
    url: "/dashboard/maintenances/" + record_id,
    dataType: 'script',
    success: function(res){
      $('.modal-body').html(res)
    }
  })
})

$(document).on("click", "#dashboard-machine-cancel-set-maintenance", function(){
  const record_id = $("#machine-maintenance-selection").attr("mid")
  __dashboard_show(record_id)
})

$(document).on("click", ".machine-set-maintenance", function () {
  $(".machine-set-maintenance").each(function (idx, elm) {
    $(elm).removeAttr('selected')
  })

  $(this).attr("selected", true)

  const machine_name = $(".modal-title").text()
  const maintenance_name = $(this).text()

  $("#machine-maintenance-selection-confirmation").find(".machine").val(machine_name)
  $("#machine-maintenance-selection-confirmation").find(".maintenance").val(maintenance_name)

  $("#machine-maintenance-selection").attr("hidden", "hidden")
  $("#machine-maintenance-selection-confirmation").removeAttr("hidden")
})

$(document).on("click", "#machine-maintenance-cancel-confirmation", function () {
  $("#machine-maintenance-selection").removeAttr("hidden")
  $("#machine-maintenance-selection-confirmation").attr("hidden", "hidden")
  $("#machine-maintenance-selection-confirmation .remarks").val("")
})

$(document).on("click", "#machine-maintenance-confirm-confirmation", function (){
  const machine_id = $("#machine-maintenance-selection").attr("mid")
  const maintenance = $(".machine-set-maintenance[selected='selected']").attr("record_id")
  const remarks = $("#machine-maintenance-selection-confirmation .remarks").val()

  $.ajax({
    url: "/dashboard/maintenances/" + machine_id,
    method: "PATCH",
    data: {
      maintenance_id: maintenance,
      remarks: remarks
    },
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    success: function (res) {
      __dashboard_show(machine_id)
      __dashboard_refresh()
    },
    error: function (jqXHR) {
      alert(jqXHR.responseJSON.message)
    }
  })
})

$(document).on("click", "#machine-maintenance-unset", function () {
  const machine_id = $("#mid").attr("mid")
  const machine_name = $(".modal-title").text()

  if (!confirm(`Apakah anda yakin STOP maintenance mesin ${machine_name}?`)) {
    return false;
  }

  $.ajax({
    url: "/dashboard/maintenances/" + machine_id,
    method: "DELETE",
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    success: function (res) {
      __dashboard_show(machine_id)
      __dashboard_refresh()
    },
    error: function (jqXHR) {
      alert(jqXHR.responseJSON.message)
    }
  })
})